import React from 'react';
import {Picture, Row, Striped, ThemedHeader, TwoColumnRow} from '../Styled';
import topPicture from '../../images/about/coach.jpg'
import profilePicture from '../../images/about/profile.jpg';

const Introduction = Row.extend`
    @media (min-width: 768px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
    @media (max-width: 767px) {
        grid-template-columns: 1fr;
    }
`;

export default function About() {
    return (
        <React.Fragment>
            <Striped>
                <TwoColumnRow>
                    <span>
                    <ThemedHeader>About Us</ThemedHeader>
                        <p>We are always there to help! If you ever have any questions, feel free to give is a call directly - we'll be glad to help in whatever way we can!</p>
                    </span>
                    <Picture src={topPicture}/>
                </TwoColumnRow>
            </Striped>
            <Striped>
                <Introduction>
                    <div>
                        <ThemedHeader>Our Goal</ThemedHeader>
                        <p>Paraglide Utah LLC is building a family of pilots. Instructor Brad Gunnuscio provides you with the service and instruction you need to grow as a pilot. Brad’s reputation as one of the country’s Premier SIV and Aerobatics coaches grows, and Brad consistently appears on the podium at international paragliding competitions. Paraglide Utah LLC instructs students with our ideals and technique, while focusing on safety and fun.</p>
                    </div>
                    <Picture className='rounded image' src={profilePicture} alt=''/>
                    <div>
                        <ThemedHeader>Brad Gunnuscio</ThemedHeader>
                        <p>is well known and highly respected for his individual accomplishments, his ability to teach new students, and to help pilots advance their flying skills. Brad provides the service and instruction you need to grow as a pilot. He has a reputation as one of the country’s premier SIV (Safety In Flight), Maneuvers and Aerobatics coaches. Brad consistently appears on the podium at International Paragliding Competitions and is one of the top ranked USA Cross-Country (XC) pilots.</p>
                    </div>
                </Introduction>
            </Striped>
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/app/components/About.js